import { makeStyles } from '@material-ui/core/styles';

const paddingDefault = '14px 12px';
const displayDefault = 'flex';

const useStyles = makeStyles({
    header:{
        backgroundColor:'#CFE2FC',
        display:displayDefault,
        padding:paddingDefault,
        alignItems:'center',
    },
    headerSpan:{
        color:'#394D60',
        fontSize:13,
        fontWeight:'bold',
        width:'80%'
    },
    headerSpanLast:{
        color:'#394D60',
        fontSize:13,
        fontWeight:'bold',
        '@media screen and (max-width:692px)':{
            display:'none'
        }
    },
    footer:{
        backgroundColor:'#CFE2FC',
        display:displayDefault,
        padding:paddingDefault
    },
    footerSpan:{
        color:'#394D60',
        fontSize:13
    },
    footerSpanLast:{
        color:'#394D60',
        fontSize:13,
        '@media screen and (max-width:692px)':{
            color:'#8B99A7',
            marginLeft:24,
            fontSize:11,
            marginTop:5
        }
    },
    arquivo:{
        padding: paddingDefault,
        display: displayDefault,
        position: 'relative',
        '@media screen and (max-width:692px)':{
            flexDirection:'column'
        }
    },
});

export default useStyles;